
const m = window.require("virtual-dom");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
